import React from "react";

const MessageSendFailure = () => {
  return (
    <span className="Txt-edited-font Txt-failed-effice">
      &emsp; - FAILED TO SEND
    </span>
  );
};

export default MessageSendFailure;
